<template>
  <div>
    <template v-if="hasProducts">
      <table class="table table-hover" style="font-size: 0.9rem;">
        <tr>
          <th>Descricao</th>
          <th>CFOP</th>
          <th>CST</th>
          <th class="text-right">Quantidade</th>
          <th class="text-right">Custo</th>
          <th class="text-right">Total</th>
          <th class="text-right">Desconto</th>
          <th class="text-right"></th>
        </tr>
        <template v-for="(row, index) in purchaseProducts">
          <tr :key="index">
            <td>
              <template v-if="row.product_base">
              <span>
                {{ row.product_base.description }}
              </span>
              <small class="text-muted">#{{ row.product_base.base_sku_id }}</small>
              </template>
              <template v-if="!row.product_base">
              <span>
                <i class="text-danger fas fa-exclamation-circle mr-1" />
                <span class="text-danger">Não encontrado</span>
                <br>
                {{ row.xProd }}
                <button class="btn btn-primary btn-sm ml-2" @click="$emit('linkProduct', index)">
                  <i class="fas fa-box" /> Vincular produto
                </button>
              </span>
              </template>
              <br />
              <small class="text-muted" v-if="row.vendor_code">
                Cod. Fornecedor: {{ row.vendor_code }} |
              </small>
              <small class="text-muted" v-if="row.gtin">
                Cod. EAN: {{ row.gtin }} |
              </small>
              <small class="text-muted" v-if="row.unit">
                Unidade: {{ row.unit }} |
              </small>
            </td>
            <td>
              {{ row.cfop }}
            </td>
            <td>
              {{ row.cst }}
            </td>
            <td class="text-right">
              {{ row.quantity | decimal }}
            </td>
            <td class="text-right">
              {{ row.price | decimal(3) }}
            </td>
            <td class="text-right">
              {{ row.quantity * row.price | decimal }}
            </td>
            <td class="text-right">
              {{ row.discount | decimal }}
            </td>
            <td class="text-right" width="12%">
              <template v-if="row.product_base">
                <button
                  class="btn btn-sm btn-light mr-1"
                  @click="$emit('edit', index)"
                >
                  <i class="text-info fas fa-pen" />
                </button>
                <button class="btn btn-sm btn-light mr-1" @click="$emit('delete', index)">
                  <i class="text-info fas fa-times" />
                </button>
                <!-- <button  class="btn btn-sm btn-light">
                  <i class="text-info fas fa-ellipsis-v"  />
                </button> -->

                <b-dropdown right toggle-class="btn btn-sm btn-light" no-caret>
                  <template v-slot:button-content>
                    <i v class="fas fa-ellipsis-v text-info" />
                  </template>

                  <b-dropdown-item
                    @click="
                      $emit('editProduct', {
                        product_base_id: row.product_base.id,
                        product_index: index,
                      })
                    "
                  >
                    Editar Produto
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </td>
          </tr>
        </template>
      </table>
    </template>
    <template v-else>
       <span class="text-info mb-5">Utilize o formulário acima para adicionar produtos...</span>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    purchaseProducts: {},
  },

  computed: {
    hasProducts() {
      return this.purchaseProducts.length > 0;
    },
  },
};
</script>

<style>
</style>